import React, { useEffect } from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import cn from "../../../utils/cn";
import { useAuthContext } from "../../../context/auth";
import BottomNav from "../BottomNav";
import { ReservationsDetailData } from "../../../Api";
import api from "../../../lib/api";

function HiluxTeamSetup() {
  const [reservations, setReservations] =
    React.useState<ReservationsDetailData>([]);

  const {
    did,
    classId,
    selectedUserIdsByRow,
    sendHandleSelectedUserIdsByRow,
  } = useAuthContext();

  useEffect(() => {
    if (did === "0" && classId) {
      api.fits.reservationsDetail(classId).then((res) => {
        setReservations(res.data);
      });
    }
  }, [classId, did]);

  const STATIONS = Array.from({ length: 8 }, (_, i) => i);

  return (
    <LandscapeProgramLayout step={5}>
      <div className="h-full w-full flex relative">
        <div className="p-[60px] flex flex-col gap-[40px] items-center w-full">
          <div className="flex items-center justify-center w-full">
            <h1 className="gradient-text text-[70px] font-bold">TEAM 설정 1</h1>
          </div>
          <div className="grid grid-cols-4 gap-x-[30px] gap-y-[24px] w-full">
            {STATIONS.map((stIdx) => (
              <div
                key={stIdx}
                className="flex flex-col gap-[16px] items-center"
              >
                <h2
                  className="text-[36px] font-extrabold text-white uppercase text-center"
                  style={{ textShadow: "0px 0px 30px rgba(0,0,0,0.25)" }}
                >
                  TEAM {stIdx + 1}
                </h2>
                <div className="p-4 gap-y-[12px] gap-x-[16px] flex flex-wrap bg-white bg-opacity-[0.12] min-h-[260px] max-h-[260px] w-full rounded-[12px] overflow-y-scroll scrollbar-hide">
                  {reservations
                    .filter((r) => r.status === "PRESENT")
                    .filter(
                      (r) =>
                        !selectedUserIdsByRow
                          .filter((_, _idx) => _idx !== stIdx)
                          .some((ids) =>
                            ids.includes(r.user?.id ?? -1)
                          )
                    )
                    .map((reservation, idx) => (
                      <button
                        className={cn(
                          "flex items-center gap-3",
                          reservation.status === "RESERVED" && "opacity-20"
                        )}
                        onClick={() => {
                          if (reservation.status === "PRESENT") {
                            sendHandleSelectedUserIdsByRow(
                              reservation.user?.id ?? -1,
                              stIdx
                            );
                          }
                        }}
                        key={idx}
                      >
                        <img
                          src={
                            reservation.user?.profileImageUrl ||
                            "/defaultProfileImage.png"
                          }
                          alt="profile"
                          className="w-[36px] h-[36px] rounded-full"
                        />
                        <h2
                          className={cn(
                            "text-[18px] text-white",
                            selectedUserIdsByRow[stIdx]?.includes(
                              reservation.user?.id ?? -1
                            ) && "text-[#53CAF5]"
                          )}
                        >
                          {reservation.user?.name}
                        </h2>
                      </button>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default HiluxTeamSetup;
